// @flow

import { HitchpinCardTypeNames } from '../../components/Shared/HitchpinCard/HitchpinCardTypeNames';
import { TrackedItems } from './TrackingEnums';

const TrackedButtonActions = Object.freeze({
  FollowStorefront: 'follow storefront',
  Bookmark: 'bookmark',
  ShowTop: 'show top',
  FilterBrowse: 'filter browse results',
  ToggleMapView: 'show map / show list view toggle',
  BackToNewListings: 'back to new listings',
  PinSelected: 'map pin selected',
  SearchPageFilter: 'search page filters button',
  IOSBannerSelected: 'IOS Banner Selected',
  IOSBannerClosed: 'IOS Banner Closed',
  NotificationBannerSelected: 'Notification Banner Selected',
  NotificationBannerClosed: 'Notification Banner Closed',
  SearchButton: 'search button',
  AboutHitchPin: 'About HitchPin',
  HowToBuyAndSell: 'How To Buy & Sell',
  HowDoPaymentsWork: 'How Do Payments Work?',
  FAQs: 'FAQs',
  BrowseFeedCreateAListing: 'create a listing',
  IndicateInterestFormError: 'Form Error',
  Login: 'Log In',
  CreateAccount: 'Create an Account',
  ImInterested: "I'm Interested",
  CloseModal: 'Close Modal',
  FindYourNextPurchase: 'Find Your Next Purchase',
  ListYourProductOrService: 'List Your Product or Service',
  BrowseTruckingOnHitchPin: 'Browse Trucking on HitchPin',
  CreateYourStorefront: 'Create Your Storefront',
  ViewMoreThan350CategoriesHere: 'View more than 350 categories here',
  BuyHay: 'Buy Hay',
  SellHay: 'Sell Hay',
  BuyEquipment: 'Buy Equipment',
  SellEquipment: 'Sell Equipment',
  BuyCattle: 'Buy Cattle',
  SellCattle: 'Sell Cattle',
  BuyTrucking: 'Buy Trucking',
  SellTrucking: 'Sell Trucking',
  MakeYourAccount: 'make your account',
  CreateAListing: 'Create a listing',
  CompleteTheTransactionHere: 'Complete the Transaction here',
  BrowseListings: 'Browse listings',
  ShareYourListingHere: 'Share Your Listing here',
  PlayVideo: 'Play Video',
  AutocompleteSearch: 'search_performed',
  AutocompleteSelected: 'search_bar_selected',
});

type ButtonActionDictionaryType = {
  [buttonAction: string]: (metaData: any) => any,
};

// Used for when an action needs lengthy property conversion
// or creation. Instead of performing this inline, add a new action
// to centralize this logic
const ButtonActionDictionary: ButtonActionDictionaryType = {
  [TrackedButtonActions.FollowStorefront]: (details: any) => {
    const eventProperties = {
      storefront_id: details.id,
      slug: details.slug,
      uid: details.uid,
      promoted: details.is_promoted > 0,
      nationwide: details.nationwide,
      new_value: details.new_value,
    };
    return eventProperties;
  },
  [TrackedButtonActions.Bookmark]: (details: any) => {
    const eventProperties = {
      card_type: details.card_type,
      id: details.id,
      uid: details.uid,
      category_id: details.category,
      promoted: details.is_promoted > 0,
      nationwide: details.nationwide,
      new_value: details.new_value,
    };
    return eventProperties;
  },
  [TrackedButtonActions.FilterBrowse]: (details: any) => {
    const eventProperties = {
      toggled_to: details.toggledTo,
    };
    return eventProperties;
  },
  [TrackedButtonActions.PinSelected]: (details: any) => {
    const eventProperties = {
      card_type:
        details.card_type === HitchpinCardTypeNames.Supply
          ? TrackedItems.Seller
          : TrackedItems.Buyer,
      id: details.id,
      uid: details.uid,
      category_id: details.category,
    };
    return eventProperties;
  },
};
export { TrackedButtonActions, ButtonActionDictionary };
